import { z } from 'zod';

export const imageEditorSearchSchema = z.object({
  mrn: z.string().optional(),
  encounterId: z.string().optional(),
});
